<template>
  <div v-show="isShow.isPOShow" class="pageOne">
    <div id="myP"></div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js'
import { TweenMax, Sine, Elastic, Power2 } from 'gsap/TweenMax'

let Application = PIXI.Application
let loader = PIXI.loader
let resources = PIXI.loader.resources
let TextureCache = PIXI.utils.TextureCache
let Graphics = PIXI.Graphics
let Sprite = PIXI.Sprite
let Text = PIXI.Text


export default {
  name: 'PageOne',
  props: {
    isShow: {
      type: Object
    },
    aniStart: {
      type: Boolean
    },
    bState: {
      type: Boolean
    }
  },
  data () {
    return {
      appStage: null,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      s5: null,
      s6: null,
      s7: null,
      s8: null,
      s9: null,
      sT: null,
      imgTBox: require('./box.png'),
      imgT1: require('./txt1.png'),
      imgT2: require('./txt2.png'),
      imgT3: require('./txt3.png'),
      imgT4: require('./txt4.png'),
      imgT5: require('./txt5.png'),
      imgT6: require('./txt6.png'),
      imgT7: require('./txt7.png'),
      img21: require('./2subway1.jpg'),
      img22: require('./2subway2.jpg'),
      img23: require('./2subway3.jpg'),
      img24a: require('./2subway4_rec.jpg.png'),
      img24b: require('./2subway4_long.jpg'),
      img2Btn: require('./btn-move.png'),
      img31: require('./3office1.jpg'),
      img32: require('./3office2.jpg'),
      img33: require('./3office3.jpg'),
      img34A: require('./3office4-bg.jpg'),
      img34B: require('./3office4-per.png'),
      img34C: require('./3office4-box.png'),
      img3Mask: require('./3office-mask.png'),
      img3Btn: require('./btn-offwork.png'),
      img41: require('./4select-f.png'),
      img42: require('./4select-m.png'),
      img43A: require('./mask-top.png'),
      img43B: require('./mask-bottom.png'),
      img4Finger: require('./finger2.png'),
      img51a: require('./5running1-u.jpg'),
      img51b: require('./5running1-a.jpg'),
      img52: require('./5running2.jpg'),
      img53: require('./5running3.jpg'),
      img53A: require('./5running3-red.png'),
      img53B: require('./5running3-green.png'),
      img54: require('./5running4.jpg'),
      img61: require('./6rm1.jpg'),
      img62: require('./6rm2.jpg'),
      img63A: require('./6rm-bg.jpg'),
      img63B: require('./6rm3_hand.png'),
      img63C: require('./6rm-box.png'),
      img71: require('./7milk1.jpg'),
      img72: require('./7milk2.jpg'),
      img73A: require('./7milk-bg.png'),
      img73B: require('./7milk3_milk.png'),
      img73C: require('./7milk3_hand.png'),
      img73D: require('./7milk3_hm.png'),
      img73E: require('./7milk-box.png'),
      img74: require('./7milk4.jpg'),
      img81: require('./8market1.jpg'),
      img82: require('./8market2.jpg'),
      img83a: require('./8market3-a.jpg'),
      img83b: require('./8market3-u.jpg'),
      img84a: require('./8market4-a.jpg'),
      img84b: require('./8market4-u.jpg'),
      img85: require('./8market5.jpg'),
      img85dog1: require('./8tail1.png'),
      img85dog2: require('./8tail2.png'),
      img91: require('./9market_f1.jpg'),
      img92: require('./9market_f2.jpg'),
      img101: require('./10market1.png'),
      img102: require('./10market2.png'),
      img103: require('./10market3.jpg')
    }
  },
  methods: {
    showNext () {
      this.isShow.isPTShow = true
      this.isShow.isPOShow = false
    },
    init () {
      this.appStage = new Application({
        width: 750,
        height: 1206,
        antialias: true,
        transparent: true,
        resolution: 1
      })
      const myP = document.getElementById('myP')
      myP.appendChild(this.appStage.view)
      this.startScene1()
      this.startScene2()
      this.startScene3()
      this.startScene4()
      this.startScene5()
      this.startScene6()
      this.startScene7()
      this.startScene8()
      this.startScene9()
      this.startSceneT()
      this.s1.visible = false
      this.s2.visible = false
      this.s3.visible = false
      this.s4.visible = false
      this.s5.visible = false
      this.s6.visible = false
      this.s7.visible = false
      this.s8.visible = false
      this.s9.visible = false
      this.sT.visible = false
    },
    s1In () {
      this.s1.visible = true
      const spr21 = this.s1.children[0]
      const spr22 = this.s1.children[1]
      const spr23 = this.s1.children[2]
      const spr24A = this.s1.children[4]
      const sprBtn = this.s1.children[5]

      TweenMax.from(spr21, 1, { alpha: 0, y: -350, ease: Sine.easeIn })
      TweenMax.from(spr22, 1, { x: -400, ease: Sine.easeIn })
      TweenMax.from(spr23, 1, { x: 700, ease: Sine.easeIn })
      TweenMax.from(spr24A, 1, { alpha: 0, ease: Sine.easeIn, onComplete: () => {
        this.$emit('hvDirective', { name: 'm01' })
      } })
      TweenMax.from(sprBtn, 1, { alpha: 0, delay: .5 })
    },
    s2In () {
      this.s1.visible = false
      this.s2.visible = true
      this.appStage.stage.removeChild(this.s1)
      const spr31 = this.s2.children[0]
      const spr32 = this.s2.children[1]
      const spr33 = this.s2.children[2]
      const sprMask = this.s2.children[6]
      const sprBtn = this.s2.children[7]
      sprMask.visible = false
      TweenMax.from(sprBtn, 1, { alpha: 0, delay: 1.6 })
      TweenMax.from(spr31, 1, { alpha: 0, y: -350, ease: Sine.easeIn })
      TweenMax.from(spr32, 1, { x: -360, ease: Sine.easeIn, onComplete: () => {
        this.$emit('hvDirective', { name: 'm11' })
        setTimeout(() => {
          this.$emit('hvDirective', { name: 'm02' })
        }, 1800)
      } })
      TweenMax.from(spr33, 1, { x: -360, ease: Sine.easeIn, delay: .5 })
    },
    sTIn () {
      this.s2.visible = false
      this.sT.visible = true
      this.$emit('hvDirective', { name: 'm03' })
      this.appStage.stage.removeChild(this.s2)
      const sprSt1 = this.sT.children[1]
      const sprSt2 = this.sT.children[2]
      const sprSt3 = this.sT.children[3]
      const sprSt4 = this.sT.children[4]
      const sprSt5 = this.sT.children[5]
      const sprSt6 = this.sT.children[6]
      const sprSt7 = this.sT.children[7]
      TweenMax.from(sprSt1, 1, { alpha: 0, ease: Sine.easeIn })
      TweenMax.from(sprSt2, 1, { alpha: 0, ease: Sine.easeIn, delay: 6 })
      TweenMax.from(sprSt3, 1, { alpha: 0, ease: Sine.easeIn, delay: 10 })
      TweenMax.from(sprSt4, 1, { alpha: 0, ease: Sine.easeIn, delay: 16 })
      TweenMax.from(sprSt5, 1, { alpha: 0, ease: Sine.easeIn, delay: 17 })
      TweenMax.from(sprSt6, 1, { alpha: 0, ease: Sine.easeIn, delay: 19 })
      TweenMax.from(sprSt7, 1, { alpha: 0, ease: Sine.easeIn, delay: 24, onComplete: () => {
        setTimeout(() => {
          this.s3In()
        }, 4000);
      } })
    },
    s3In () {
      this.sT.visible = false
      this.s3.visible = true
      this.appStage.stage.removeChild(this.sT)
      const spr41 = this.s3.children[0]
      const spr42 = this.s3.children[1]
      const spr43A = this.s3.children[2]
      const spr43B = this.s3.children[3]
      const sprHandBox1 = this.s3.children[4] //手指容器
      const sprHand1 = sprHandBox1.children[0] //手指
      

      /*TweenMax.from(sprHand1, 1.4, { alpha: 0, delay: 1.4, repeat: 3, onComplete: () => {
        TweenMax.to(sprHand1, 1, { x: 125, onComplete: () => {
          TweenMax.to(sprHand1, 1.4, { alpha: 0, repeat: 3 })
        } })
      } })*/

      //手指提示
      TweenMax.from(sprHandBox1, 1.4, { alpha: 1,onComplete:()=>{
        this.handtip();
      }})



      TweenMax.from(spr41, 1, { alpha: .2, x: -600, ease: Sine.easeIn })
      TweenMax.from(spr42, 1, { alpha: .2, x: 600, ease: Sine.easeIn })
      TweenMax.from(spr43A, 1, { alpha: .2, y: -120, ease: Sine.easeIn, delay: 1.2 })
      TweenMax.from(spr43B, 1, { alpha: .2, y: 1326, ease: Sine.easeIn, delay: 1.2 })
    },
    handtip(){
      let _this=this
      const sprHandBox1 = this.s3.children[4] //手指容器
      const sprHand1 = sprHandBox1.children[0] //手指
      TweenMax.from(sprHand1, 1.4, { alpha: 0, repeat: 3})
      TweenMax.to(sprHandBox1, 1, { x: 125,y:465, delay: 4.2, onComplete:()=>{
        TweenMax.from(sprHand1, 1.4, { alpha: 0, repeat: 3})
        TweenMax.to(sprHandBox1, 1, { x: 554,y:605,delay: 4.2,onComplete:()=>{
          _this.handtip()
        }})
      }})
    },
    s4In () {
      this.s3.visible = false
      this.s4.visible = true
      const carSpr = this.s4.children[1]
      const runningSpr = this.s4.children[5]
      const lightSprR = this.s4.children[3]
      const lightSprG = this.s4.children[4]
      const buildingLight = this.s4.children[6]
      // lightSprR.visible = false
      lightSprG.visible = false

      this.$emit('hvDirective', { name: 'm04' })

      TweenMax.from(lightSprR, 1, { alpha: 0, ease: Sine.easeIn, repeat: 2, delay: 1.5, onComplete: () => {
        lightSprR.visible = false
        lightSprG.visible = true
        
        setTimeout(() => {
          this.s5In()
          lightSprR.visible = true
        }, 2500)
      } } )
      TweenMax.from(buildingLight, 1.5, { alpha: 0, repeat: -1 })
      TweenMax.from(carSpr, 1, { x: -400, alpha: .4 } )
      TweenMax.from(runningSpr, 1, { y: 1200, alpha: .4 })
    },
    s5In () {
      this.s4.visible = false
      this.s5.visible = true
      const s1Spr = this.s5.children[0]
      const s2Spr = this.s5.children[1]
      const handSpr = this.s5.children[3]

      this.$emit('hvDirective', { name: 'm05' })

      TweenMax.from(s1Spr, 1, { x: -700, alpha: .4 })
      TweenMax.from(s2Spr, 1, { x: -700, alpha: .4, delay: .5 })
      TweenMax.from(handSpr, 1, { x: -500, delay: 1.5, onComplete: () => {
        
        setTimeout(() => {
          this.s6In()
        }, 3000)
      } })
    },
    s6In () {
      this.s5.visible = false
      this.s6.visible = true
      const s61Spr = this.s6.children[0]
      const s62Spr = this.s6.children[1]
      const s64Spr = this.s6.children[3]
      const milkSpr = this.s6.children[4]
      const handSpr = this.s6.children[5]
      const hmSpr = this.s6.children[6]
      hmSpr.visible = false

      TweenMax.from(s61Spr, 1, { x: 750, alpha: .4, onComplete: () => {
        this.$emit('hvDirective', { name: 'm06' })
      } })
      TweenMax.from(s62Spr, 1, { x: 750, alpha: .4, delay: .4 })
      TweenMax.from(s64Spr, 1, { x: 750, alpha: .4, delay: .7 })
      TweenMax.from(handSpr, 1, { x: -240, delay: 2.5, onComplete: () => {
        handSpr.visible = false
        milkSpr.visible = false
        hmSpr.visible = true
        setTimeout(() => {
          TweenMax.to(hmSpr, 1, { x: -210, onComplete: () => {
            setTimeout(() => {
              this.showNext()
              this.s6.visible = false
              milkSpr.visible = true
              handSpr.visible = true
              hmSpr.visible = true
            }, 3500)
          } })
        }, 500)
      } })
    },
    s7In () {
      this.s3.visible = false
      this.s7.visible = true
      const s71Spr = this.s7.children[0]
      const s72Spr = this.s7.children[1]
      const dogUSpr = this.s7.children[5]
      const girlSpr = this.s7.children[6]
      const dog1Spr = this.s7.children[7]
      const dog2Spr = this.s7.children[8]

      TweenMax.from(s71Spr, 1, { x: -700, alpha: .4 })
      TweenMax.from(s72Spr, 1, { x: -700, delay: .5, alpha: .4, onComplete: () => {
        this.$emit('hvDirective', { name: 'm07' })
        setTimeout(() => {
          this.s8In()
        }, 7000)
      } })
      TweenMax.to(dogUSpr, 1, { alpha: 0, repeat: 2, delay: 2 })
      TweenMax.to(girlSpr, 1, { alpha: 0, repeat: 2, delay: 4 })
      TweenMax.to(dog1Spr, .6, { alpha:0, repeat: -1 })
      TweenMax.to(dog2Spr, .6, { alpha:0, repeat: -1, delay: .3 })
    },
    s8In () {
      this.s7.visible = false
      this.s8.visible = true

      const s81Spr = this.s8.children[0]
      const s82Spr = this.s8.children[1]
      TweenMax.from(s81Spr, 1, { x: -750, alpha: .4 })
      TweenMax.from(s82Spr, 1, { x: -750, alpha: .4, delay: .5, onComplete: () => {
        this.$emit('hvDirective', { name: 'm08' })
        setTimeout(() => {
          this.s9In()
        }, 4000)
      } })
    },
    s9In () {
      this.s8.visible = false
      this.s9.visible = true

      const s91Spr = this.s9.children[0]
      const s92Spr = this.s9.children[1]
      const s93Spr = this.s9.children[2]

      TweenMax.from(s91Spr, 1, { x: -740, alpha: .4 })
      TweenMax.from(s92Spr, 1, { x: 750, alpha: .4 })
      TweenMax.from(s93Spr, 1, { y: 1206, alpha: .4, onComplete: () => {
        this.$emit('hvDirective', { name: 'm09' })
        setTimeout(() => {
          this.showNext()
          this.s9.visible = false
        }, 7500)
      } })
    },
    _moveTrain () {
      const spr24B = this.s1.children[3]
      this.$emit('hvDirective', { name: 'm10' })
      TweenMax.to(spr24B, 3, { x: -480, onComplete: () => {
        this.s2In()
      }})
    },
    _movePerson () {
      const spr34B = this.s2.children[4]
      const sprMask = this.s2.children[6]
      sprMask.visible = true
      TweenMax.to(spr34B, 1, { x: 750, alpha: 0, ease: Sine.easeIn, onComplete: () => {
        setTimeout(() => {
          this.sTIn()
        }, 1000)
      } })
    },
    startScene1 () {
      this.s1 = new PIXI.Container()
      let scene21Img = PIXI.Texture.fromImage(this.img21)
      let scene21Spr = new Sprite(scene21Img)
      scene21Spr.width = 708
      scene21Spr.height = 364
      scene21Spr.position.set(21, 0)
      this.s1.addChild(scene21Spr)

      let scene22Img = PIXI.Texture.fromImage(this.img22)
      let scene22Spr = new Sprite(scene22Img)
      scene22Spr.width = 260
      scene22Spr.height = 330
      scene22Spr.position.set(21, 397)
      this.s1.addChild(scene22Spr)

      let scene23Img = PIXI.Texture.fromImage(this.img23)
      let scene23Spr = new Sprite(scene23Img)
      scene23Spr.width = 433
      scene23Spr.height = 331
      scene23Spr.position.set(296, 397)
      this.s1.addChild(scene23Spr)

      let scene24BImg = PIXI.Texture.fromImage(this.img24b)
      let scene24BSpr = new Sprite(scene24BImg)
      scene24BSpr.width = 1203
      scene24BSpr.height = 445
      scene24BSpr.position.set(21, 758)
      this.s1.addChild(scene24BSpr)

      let scene24AImg = PIXI.Texture.fromImage(this.img24a)
      let scene24ASpr = new Sprite(scene24AImg)
      scene24ASpr.width = 750
      scene24ASpr.height = 448
      scene24ASpr.position.set(0, 758)
      this.s1.addChild(scene24ASpr)

      let scene2Btn = PIXI.Texture.fromImage(this.img2Btn)
      let scene2BtnSpr = new Sprite(scene2Btn)
      scene2BtnSpr.width = 240
      scene2BtnSpr.height = 96
      scene2BtnSpr.scale.set(0.8, 0.8);
      scene2BtnSpr.anchor.set(.5, .5)
      scene2BtnSpr.position.set(375, 1150)
      scene2BtnSpr.interactive = true
      scene2BtnSpr.on('tap', (evt) => {
        scene2BtnSpr.visible=false
        console.log('clicked train')
        this._moveTrain()
      })
      this.s1.addChild(scene2BtnSpr)


      

      this.appStage.stage.addChild(this.s1)

      TweenMax.from(scene2BtnSpr.scale,3,{x:1,y:1,repeat:-1,ease:Linear.easeNone})
    },
    startScene2 () {
      this.s2 = new PIXI.Container()

      let scene31Img = PIXI.Texture.fromImage(this.img31)
      const spr31 = new Sprite(scene31Img)
      spr31.width = 688
      spr31.height = 384
      spr31.position.set(24, 0)
      this.s2.addChild(spr31)

      let scene32Img = PIXI.Texture.fromImage(this.img32)
      const spr32 = new Sprite(scene32Img)
      spr32.width = 347
      spr32.height = 361
      spr32.position.set(21, 410)
      this.s2.addChild(spr32)

      let scene33Img = PIXI.Texture.fromImage(this.img33)
      const spr33 = new Sprite(scene33Img)
      spr33.width = 346
      spr33.height = 399
      spr33.position.set(21, 798)
      this.s2.addChild(spr33)

      let scene34AImg = PIXI.Texture.fromImage(this.img34A)
      const spr34A = new Sprite(scene34AImg)
      spr34A.width = 324
      spr34A.height = 776
      spr34A.position.set(400, 410)
      this.s2.addChild(spr34A)

      let scene34BImg = PIXI.Texture.fromImage(this.img34B)
      const spr34B = new Sprite(scene34BImg)
      spr34B.width = 233
      spr34B.height = 594
      spr34B.anchor.set(.5, .5)
      spr34B.position.set(592, 810)
      this.s2.addChild(spr34B)

      let scene34CImg = PIXI.Texture.fromImage(this.img34C)
      const spr34C = new Sprite(scene34CImg)
      spr34C.width = 346
      spr34C.height = 782
      spr34C.position.set(400, 410)
      this.s2.addChild(spr34C)

      let scene3MaskImg = PIXI.Texture.fromImage(this.img3Mask)
      const spr34Mask = new Sprite(scene3MaskImg)
      spr34Mask.width = 317
      spr34Mask.height = 775
      spr34Mask.position.set(400, 414)
      this.s2.addChild(spr34Mask)

      let scene3BtnImg = PIXI.Texture.fromImage(this.img3Btn)
      const spr34Btn = new Sprite(scene3BtnImg)
      spr34Btn.width = 240
      spr34Btn.height = 96
      spr34Btn.anchor.set(.5, .5)
      spr34Btn.scale.set(0.8, 0.8);
      spr34Btn.position.set(375, 1140)
      spr34Btn.interactive = true
      spr34Btn.on('tap', (evt) => {
        console.log('move person')
        spr34Btn.visible=false
        this._movePerson()
      })
      this.s2.addChild(spr34Btn)

      

      this.appStage.stage.addChild(this.s2)

      TweenMax.from(spr34Btn.scale,3,{x:1,y:1,repeat:-1,ease:Linear.easeNone})

    },
    startScene3 () {
      this.s3 = new PIXI.Container()
      let scene41Img = PIXI.Texture.fromImage(this.img41)
      const spr41 = new Sprite(scene41Img)
      spr41.width = 750
      spr41.height = 1206
      spr41.position.set(0, 0)
      const hitArea41 = new PIXI.Polygon(0, 10, 0, 1206, 720, 1206)
      spr41.hitArea = hitArea41
      spr41.interactive = true
      spr41.on('tap', (evt) => {
        console.log(evt + 'left')
        this.$emit('changeMusic')
        this.$emit('selectSex', '1')
        this.s7In()
        sprFinger1.visible = false
        sprFinger2.visible = false
      })
      this.s3.addChild(spr41)

      let scene42Img = PIXI.Texture.fromImage(this.img42)
      const spr42 = new Sprite(scene42Img)
      spr42.width = 750
      spr42.height = 1206
      const hitArea42 = new PIXI.Polygon(21, 0, 750, 0, 750, 1206)
      spr42.hitArea = hitArea42
      spr42.interactive = true
      spr42.on('tap', (evt) => {
        console.log(evt + 'right')
        this.$emit('changeMusic')
        this.$emit('selectSex', '0')
        this.s4In()
        sprFinger1.visible = false
        sprFinger2.visible = false
      })
      spr42.position.set(0, 0)
      this.s3.addChild(spr42)

      let scene43AImg = PIXI.Texture.fromImage(this.img43A)
      const spr43A = new Sprite(scene43AImg)
      spr43A.width = 750
      spr43A.height = 115
      spr43A.position.set(0, 0)
      this.s3.addChild(spr43A)

      let scene43BImg = PIXI.Texture.fromImage(this.img43B)
      const spr43B = new Sprite(scene43BImg)
      spr43B.width = 750
      spr43B.height = 115
      spr43B.anchor.set(0, 1)
      spr43B.position.set(0, 1206)
      this.s3.addChild(spr43B)

      //手指提示
      let fingbox = new PIXI.Container()
      fingbox.position.set(554, 605)
      this.s3.addChild(fingbox)

      let scene4Finger = PIXI.Texture.fromImage(this.img4Finger)
      const sprFinger1 = new Sprite(scene4Finger)
      const sprFinger2 = new Sprite(scene4Finger)
      sprFinger1.width = 72
      sprFinger1.height = 96
      sprFinger1.anchor.set(.5, .5)
      sprFinger1.position.set(0, 0)

      fingbox.addChild(sprFinger1)

      sprFinger2.width = 72
      sprFinger2.height = 87
      sprFinger2.anchor.set(.5, .5)
      sprFinger2.position.set(325, 805)
      // this.s3.addChild(sprFinger2)

      this.appStage.stage.addChild(this.s3)
    },
    startScene4 () {
      this.s4 = new PIXI.Container()

      let scene51AImg = PIXI.Texture.fromImage(this.img51a)
      let scene51ASpr = new Sprite(scene51AImg)
      scene51ASpr.width = 708
      scene51ASpr.height = 333
      scene51ASpr.position.set(21, 0)
      this.s4.addChild(scene51ASpr)

      let scene52Img = PIXI.Texture.fromImage(this.img52)
      let scene52Spr = new Sprite(scene52Img)
      scene52Spr.width = 458
      scene52Spr.height = 337
      scene52Spr.position.set(21, 362)
      this.s4.addChild(scene52Spr)

      let scene53Img = PIXI.Texture.fromImage(this.img53)
      let scene53Spr = new Sprite(scene53Img)
      scene53Spr.width = 233
      scene53Spr.height = 337
      scene53Spr.position.set(496, 362)
      this.s4.addChild(scene53Spr)

      let scene53AImg = PIXI.Texture.fromImage(this.img53A)
      let scene53ASpr = new Sprite(scene53AImg)
      scene53ASpr.width = 160
      scene53ASpr.height = 315
      scene53ASpr.anchor.set(.5, 0)
      scene53ASpr.position.set(610, 348)
      this.s4.addChild(scene53ASpr)

      let scene53BImg = PIXI.Texture.fromImage(this.img53B)
      let scene53BSpr = new Sprite(scene53BImg)
      scene53BSpr.width = 160
      scene53BSpr.height = 315
      scene53BSpr.anchor.set(.5, 0)
      scene53BSpr.position.set(610, 348)
      this.s4.addChild(scene53BSpr)

      let scene54Img = PIXI.Texture.fromImage(this.img54)
      let scene54Spr = new Sprite(scene54Img)
      scene54Spr.width = 708
      scene54Spr.height = 477
      scene54Spr.position.set(21, 729)
      this.s4.addChild(scene54Spr)

      let scene51BImg = PIXI.Texture.fromImage(this.img51b)
      let scene51BSpr = new Sprite(scene51BImg)
      scene51BSpr.width = 708
      scene51BSpr.height = 333
      scene51BSpr.position.set(21, 0)
      this.s4.addChild(scene51BSpr)

      this.appStage.stage.addChild(this.s4)
    },
    startScene5 () {
      this.s5 = new PIXI.Container()

      let scene61Img = PIXI.Texture.fromImage(this.img61)
      let scene61Spr = new Sprite(scene61Img)
      scene61Spr.width = 694
      scene61Spr.height = 383
      scene61Spr.position.set(26, 0)
      this.s5.addChild(scene61Spr)

      let scene62Img = PIXI.Texture.fromImage(this.img62)
      let scene62Spr = new Sprite(scene62Img)
      scene62Spr.width = 692
      scene62Spr.height = 404
      scene62Spr.position.set(30, 405)
      this.s5.addChild(scene62Spr)

      let scene63AImg = PIXI.Texture.fromImage(this.img63A)
      let scene63ASpr = new Sprite(scene63AImg)
      scene63ASpr.width = 690
      scene63ASpr.height = 360
      scene63ASpr.position.set(29, 836)
      this.s5.addChild(scene63ASpr)

      let scene63BImg = PIXI.Texture.fromImage(this.img63B)
      let scene63BSpr = new Sprite(scene63BImg)
      scene63BSpr.width = 563
      scene63BSpr.height = 331
      scene63BSpr.anchor.set(0, 1)
      scene63BSpr.position.set(21, 1198)
      this.s5.addChild(scene63BSpr)

      let scene63CImg = PIXI.Texture.fromImage(this.img63C)
      let scene63CSpr = new Sprite(scene63CImg)
      scene63CSpr.width = 726
      scene63CSpr.height = 363
      scene63CSpr.position.set(0, 836)
      this.s5.addChild(scene63CSpr)

      this.appStage.stage.addChild(this.s5)
    },
    startScene6 () {
      this.s6 = new PIXI.Container()

      let scene71Img = PIXI.Texture.fromImage(this.img71)
      let scene71Spr = new Sprite(scene71Img)
      scene71Spr.width = 694
      scene71Spr.height = 431
      scene71Spr.position.set(21, 0)
      this.s6.addChild(scene71Spr)

      let scene72Img = PIXI.Texture.fromImage(this.img72)
      let scene72Spr = new Sprite(scene72Img)
      scene72Spr.width = 692
      scene72Spr.height = 419
      scene72Spr.position.set(23, 450)
      this.s6.addChild(scene72Spr)

      let scene73AImg = PIXI.Texture.fromImage(this.img73A)
      let scene73ASpr = new Sprite(scene73AImg)
      scene73ASpr.width = 341
      scene73ASpr.height = 297
      scene73ASpr.position.set(21, 895)
      this.s6.addChild(scene73ASpr)

      let scene74Img = PIXI.Texture.fromImage(this.img74)
      let scene74Spr = new Sprite(scene74Img)
      scene74Spr.width = 323
      scene74Spr.height = 296
      scene74Spr.position.set(394, 895)
      this.s6.addChild(scene74Spr)

      let scene73BImg = PIXI.Texture.fromImage(this.img73B)
      let scene73BSpr = new Sprite(scene73BImg)
      scene73BSpr.width = 51
      scene73BSpr.height = 80
      scene73BSpr.anchor.set(.5, 1)
      scene73BSpr.position.set(230, 1130)
      this.s6.addChild(scene73BSpr)

      let scene73CImg = PIXI.Texture.fromImage(this.img73C)
      let scene73CSpr = new Sprite(scene73CImg)
      scene73CSpr.width = 229
      scene73CSpr.height = 167
      scene73CSpr.anchor.set(0, 1)
      scene73CSpr.position.set(21, 1194)
      this.s6.addChild(scene73CSpr)

      let scene73DImg = PIXI.Texture.fromImage(this.img73D)
      let scene73DSpr = new Sprite(scene73DImg)
      scene73DSpr.width = 202
      scene73DSpr.height = 124
      scene73DSpr.anchor.set(0, 1)
      scene73DSpr.position.set(21, 1194)
      this.s6.addChild(scene73DSpr)

      let scene73EImg = PIXI.Texture.fromImage(this.img73E)
      let scene73ESpr = new Sprite(scene73EImg)
      scene73ESpr.width = 361
      scene73ESpr.height = 298
      scene73ESpr.position.set(0, 895)
      this.s6.addChild(scene73ESpr)

      this.appStage.stage.addChild(this.s6)
    },
    startScene7 () {
      this.s7 = new PIXI.Container()

      let scene81Img = PIXI.Texture.fromImage(this.img81)
      let scene81Spr = new Sprite(scene81Img)
      scene81Spr.width = 716
      scene81Spr.height = 389
      scene81Spr.position.set(21, 0)
      this.s7.addChild(scene81Spr)

      let scene82Img = PIXI.Texture.fromImage(this.img82)
      let scene82Spr = new Sprite(scene82Img)
      scene82Spr.width = 435
      scene82Spr.height = 494
      scene82Spr.position.set(21, 421)
      this.s7.addChild(scene82Spr)

      let scene83Img = PIXI.Texture.fromImage(this.img83b)
      let scene83Spr = new Sprite(scene83Img)
      scene83Spr.width = 265
      scene83Spr.height = 230
      scene83Spr.position.set(468, 421)
      this.s7.addChild(scene83Spr)

      let scene84Img = PIXI.Texture.fromImage(this.img84b)
      let scene84Spr = new Sprite(scene84Img)
      scene84Spr.width = 265
      scene84Spr.height = 247
      scene84Spr.position.set(468, 668)
      this.s7.addChild(scene84Spr)

      let scene85Img = PIXI.Texture.fromImage(this.img85)
      let scene85Spr = new Sprite(scene85Img)
      scene85Spr.width = 716
      scene85Spr.height = 259
      scene85Spr.position.set(21, 947)
      this.s7.addChild(scene85Spr)

      let scene8BImg = PIXI.Texture.fromImage(this.img83a)
      let scene83BSpr = new Sprite(scene8BImg)
      scene83BSpr.width = 265
      scene83BSpr.height = 230
      scene83BSpr.position.set(468, 421)
      this.s7.addChild(scene83BSpr)

      let scene84BImg = PIXI.Texture.fromImage(this.img84a)
      let scene84BSpr = new Sprite(scene84BImg)
      scene84BSpr.width = 265
      scene84BSpr.height = 247
      scene84BSpr.position.set(468, 668)
      this.s7.addChild(scene84BSpr)

      let scene85AImg = PIXI.Texture.fromImage(this.img85dog1)
      let scene85ASpr = new Sprite(scene85AImg)
      scene85ASpr.width = 28
      scene85ASpr.height = 30
      scene85ASpr.anchor.set(1, 0)
      scene85ASpr.position.set(432, 1120)
      this.s7.addChild(scene85ASpr)

      let scene85BImg = PIXI.Texture.fromImage(this.img85dog2)
      let scene85BSpr = new Sprite(scene85BImg)
      scene85BSpr.width = 35
      scene85BSpr.height = 20
      scene85BSpr.anchor.set(1, 0)
      scene85BSpr.position.set(432, 1134)
      this.s7.addChild(scene85BSpr)

      this.appStage.stage.addChild(this.s7)
    },
    startScene8 () {
      this.s8 = new PIXI.Container()

      let scene91Img = PIXI.Texture.fromImage(this.img91)
      let scene91Spr = new Sprite(scene91Img)
      scene91Spr.width = 693
      scene91Spr.height = 327
      scene91Spr.position.set(24, 40)
      this.s8.addChild(scene91Spr)

      let scene92Img = PIXI.Texture.fromImage(this.img92)
      let scene92Spr = new Sprite(scene92Img)
      scene92Spr.width = 694
      scene92Spr.height = 731
      scene92Spr.position.set(25, 444)
      this.s8.addChild(scene92Spr)

      this.appStage.stage.addChild(this.s8)
    },
    startScene9 () {
      this.s9 = new PIXI.Container()

      let scene101Img = PIXI.Texture.fromImage(this.img101)
      let scene101Spr = new Sprite(scene101Img)
      scene101Spr.width = 654
      scene101Spr.height = 642
      scene101Spr.position.set(24, 0)
      this.s9.addChild(scene101Spr)

      let scene102Img = PIXI.Texture.fromImage(this.img102)
      let scene102Spr = new Sprite(scene102Img)
      scene102Spr.width = 673
      scene102Spr.height = 645
      scene102Spr.position.set(38, 0)
      this.s9.addChild(scene102Spr)

      let scene103Img = PIXI.Texture.fromImage(this.img103)
      let scene103Spr = new Sprite(scene103Img)
      scene103Spr.width = 692
      scene103Spr.height = 485
      scene103Spr.position.set(26, 700)
      this.s9.addChild(scene103Spr)

      this.appStage.stage.addChild(this.s9)
    },
    startSceneT () {
      this.sT = new PIXI.Container()
      let sceneTImg = PIXI.Texture.fromImage(this.imgTBox)
      this.sprT = new Sprite(sceneTImg)
      this.sprT.width = 730
      this.sprT.height = 1178
      this.sprT.anchor.set(.5, .5)
      this.sprT.position.set(375, 603)
      this.sT.addChild(this.sprT)

      let sceneT1Img = PIXI.Texture.fromImage(this.imgT1)
      this.sprT1 = new Sprite(sceneT1Img)
      this.sprT1.width = 478
      this.sprT1.height = 48
      this.sprT1.anchor.set(.5, .5)
      this.sprT1.position.set(375, 265)
      this.sT.addChild(this.sprT1)

      let sceneT2Img = PIXI.Texture.fromImage(this.imgT2)
      this.sprT2 = new Sprite(sceneT2Img)
      this.sprT2.width = 510
      this.sprT2.height = 48
      this.sprT2.anchor.set(.5, .5)
      this.sprT2.position.set(375, 332)
      this.sT.addChild(this.sprT2)

      let sceneT3Img = PIXI.Texture.fromImage(this.imgT3)
      this.sprT3 = new Sprite(sceneT3Img)
      this.sprT3.width = 648
      this.sprT3.height = 48
      this.sprT3.anchor.set(.5, .5)
      this.sprT3.position.set(375, 398)
      this.sT.addChild(this.sprT3)

      let sceneT4Img = PIXI.Texture.fromImage(this.imgT4)
      this.sprT4 = new Sprite(sceneT4Img)
      this.sprT4.width = 456
      this.sprT4.height = 48
      this.sprT4.anchor.set(.5, .5)
      this.sprT4.position.set(375, 464)
      this.sT.addChild(this.sprT4)

      let sceneT5Img = PIXI.Texture.fromImage(this.imgT5)
      this.sprT5 = new Sprite(sceneT5Img)
      this.sprT5.width = 98
      this.sprT5.height = 48
      this.sprT5.anchor.set(.5, .5)
      this.sprT5.position.set(375, 532)
      this.sT.addChild(this.sprT5)

      let sceneT6Img = PIXI.Texture.fromImage(this.imgT6)
      this.sprT6 = new Sprite(sceneT6Img)
      this.sprT6.width = 430
      this.sprT6.height = 48
      this.sprT6.anchor.set(.5, .5)
      this.sprT6.position.set(375, 932)
      this.sT.addChild(this.sprT6)

      let sceneT7Img = PIXI.Texture.fromImage(this.imgT7)
      this.sprT7 = new Sprite(sceneT7Img)
      this.sprT7.width = 430
      this.sprT7.height = 48
      this.sprT7.anchor.set(.5, .5)
      this.sprT7.position.set(375, 998)
      this.sT.addChild(this.sprT7)

      this.appStage.stage.addChild(this.sT)
    }
  },
  mounted () {
    this.init()
  },
  watch: {
    aniStart () {
      this.s1In()
    },
    bState () {
      this.isShow.isPRShow = false
      this.isShow.isPOShow = true
      this.s3In()
    }
  }
}
</script>

<style lang="less" scoped>
.pageOne {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
